// Allows to access these objects in script tags
import jquery from "jquery";
window.jquery = jquery;
window.jQuery = jquery;
window.$ = jquery;
import Clipboard from "clipboard";
window.Clipboard = Clipboard;
import bsCustomFileInput from 'bs-custom-file-input';
window.bsCustomFileInput = bsCustomFileInput;
